import React from 'react';
import ContentTypeFactory from './factory';
import parseStorageHtml from './parseStorageHtml';

/**
 * Page Builder component for rendering Page Builder master storage format in React
 *
 * @param data
 * @returns {*}
 * @constructor
 */
export default function PageBuilder(_ref) {
  var {
    html,
    classes
  } = _ref;
  var data = parseStorageHtml(html);
  return data.children.map((child, i) => {
    return /*#__PURE__*/React.createElement("div", {
      className: classes.root,
      key: i
    }, /*#__PURE__*/React.createElement(ContentTypeFactory, {
      data: child
    }));
  });
}